const translationKeys = {
  betAmount: 'ベット額',
  maxBetAmountLimit: '最高ベット額の上限{{value}}を越えました',
  minBetAmountLimit: '最低ベット額は{{value}}です。',
  noBalance: 'ベット額がウォレット残高を越えています',
  noAutoCashout: '自動レートは必須です。',
  autoRateWarning: '自動レートは次の額以上である必要があります：',
  autoRateWarningMaxOdds: '自動レートは次の額以下である必要があります：',
  limit: 'の上限を越えました。',
  notAchieved: 'に到達しませんでした。',
  maxBetAmount: '最高ベット額',
  minBetAmount: '最低ベット額',
  BET: 'ベット',
  PLACE_BET: 'ベット',
  CASH_OUT_BET: 'キャッシュアウト',
  WAIT: '待機',
  PLACE: '実行',
  CASHOUT_AT: 'キャッシュアウトする倍率：',
  CANCEL: 'キャンセル',
  CANCEL_BET: 'キャンセル',
  isRequired: '{{label}}は必須です',
  404: '404',
  pageNotFound: 'お探しのページが見つかりません。',
  error: 'エラー',
  somethingWentWrong: 'エラーが発生しました。',
  announcement_1: 'ゲーム開始まで：',
  announcement_2: 'キャッシュアウト完了済み：',
  announcement_3: 'ベットクローズまで：',
  announcement_4: 'ベット受け付け中：',
  BETS: 'ベット',
  HUBERT_TITLE: 'Hubert Hits',
  SOUND: 'サウンド',
  MUSIC: '音楽 ',
  ANIMATION: 'アニメーション',
  GAME_INFO: 'ゲーム情報',
  HOW_TO_PLAY: 'プレイのしかた',
  GAME_RULES: 'ゲームルール',
  BET_HISTORY: 'ベット履歴',
  LEADERBOARD: 'リーダーボード',
  GAME_LIMIT: 'ゲームリミット',
  BALANCE: '残高',
  WAITING_ROUND: '次回のラウンドまで待機中',
  ROUND_ID: 'ラウンドID',
  ERROR_MESSAGE: 'エラーメッセージ',
  ERROR_DESC: 'セッションが時間切れになったか、アクセストークンが承認されませんでした',
  GAME_LIMIT_TITLE: 'ゲームリミット',
  MIN_BET: '最低ベット額',
  MAX_BET: '最高ベット額',
  MAX_WIN: '1回のベットで得られる最高賞金',
  NO_DATA: 'データが見つかりませんでした',
  PLAYER: 'プレイヤー',
  MULTIPLIER: 'マルチプライヤー',
  WIN: '勝ち',
  MY_BET: 'マイベット',
  CASHOUT: 'キャッシュアウト',
  DATE: '日付',
  GAME_INFO_DESC: 'Hubert Hitsは、楽しく遊べる「クラッシュ」系のマルチプレイヤーゲームです。このゲームに含まれるマルチプライヤーは1.00倍からで、クラッシュが起こるまで、事前にランダムに決定された値まで上昇します。このゲームの目的は、クラッシュが起こる前にキャッシュアウトし、マルチプライヤーで倍増した賭け金を確保することです。いつも大忙しのドライバーと一緒に、この街の混雑した通りで迫りくる渋滞を回避しましょう。',
  RTP: 'RTP',
  GAME_VERSION: 'ゲームのバージョン',
  HOW_TO_PLAY_DESC_1: '始めるには、ベット額を選択し、「ベット」ボタンをクリックまたはタップします。「ベットクローズ」のメッセージが画面に表示されるまでは、次のゲームラウンドの賭けの実施や変更を続けることができます。',
  HOW_TO_PLAY_DESC_2: '現在のラウンドのベット総額が「ベット総額」ウィンドウに表示されます。ベッティングタイムが終了すると、マルチプライヤーの開始値である「1.00倍」が表示されます。その後マルチプライヤーは上昇し始めます。当初はゆっくりと、そして次第に上昇するにつれ速くなっていきます。賞金は全額を一度にキャッシュアウトできます。賞金はキャッシュアウトのタイミングによって増額しますので、クラッシュが起こる前を見計らってキャッシュアウトようにしましょう。クラッシュが起きるとそのゲームラウンドは終了し、それまでにキャッシュアウトされなかった金額はすべて没収されます。',
  HOW_TO_PLAY_DESC_5: 'キャッシュアウトすることを選択した賭け金にマルチプライヤーを賭けた額が賞金額となります（クラッシュ前にキャッシュアウトした場合）。画面に表示される勝利通知には、獲得した賞金額が含まれます。',
  GAME_FUNCTIONS: 'ゲームの機能',
  BET_CASHOUT: 'ベットとキャッシュアウト',
  HOW_TO_PLAY_DESC_6: '金額を選択し、「ベット」ボタンを押してベットを確定します。',
  HOW_TO_PLAY_DESC_7: '2つ目のベットを設定することにより、1つのラウンドで2つの賭けを実施することができます。ただし、これは2つ目の「ベット」ボタンを押すまでは有効とはなりません。',
  HOW_TO_PLAY_DESC_8: '詳しい情報は、「キャッシュアウト」セクションをご覧ください。キャッシュアウトをすると、現在のゲームが終了し、次回のラウンドでベットを始めることができます。',
  RULES_DESC_1: 'クラッシュが起こるたびに、マルチプライヤーが開始値1.00倍からランダムな既定値まで上昇します。{{ value }}倍がクラッシュマルチプライヤーとしては最高値になります。',
  PLACING_BET: 'ベットを実施中',
  RULES_DESC_3: '最低ベット額{{value}}、',
  RULES_DESC_3_1: '最高ベット額{{ value }}',
  RULES_DESC_3_2: 'デフォルトのベットレベル{{ value }}が「ゲームリミット」タブに表示されます。',
  GAME_INDICATOR: 'ゲーム情報インジケーター',
  RULES_DESC_5: 'ベット期間終了後にゲームに参加した場合や、現在のラウンドに実施したベットがない場合、「次回ラウンドまで待機中」というメッセージが表示されます。観戦者として、現在のラウンドを見守りながら、次のラウンドのベットを実施することができます。',
  RULES_DESC_6: '現在のラウンドで賭けが承認されると、次のゲームが表示されます。',
  GAME_STARTS: 'ゲーム開始まで：3秒',
  RULES_DESC_7: 'ベットを確定したら、全ベッティングエリアが無効になり、ベッティング期間が終了するとベットはクローズされます。',
  BALANCE_INDICATOR: '残高インジケーター',
  RULES_DESC_8: '利用可能な資金と通貨が「残高インジケーター」に表示されます。賭けをカバーできる残高があることを確認しましょう。賭け、勝ちまたは負けの後に残高が更新されない場合は、ゲームを再起動してください。',
  BET_INDICATOR: 'ベット総額インジケーター',
  RULES_DESC_9: '現在のゲームラウンドでの賭け金の総額は、「ベット総額インジケーター」で表示されます。各ゲームラウンドには独自の「ラウンドID」番号が割り当てられ、画面右下に表示されます。お住まいの地域の現地時間は「タイムインジケーター」に表示されます（例：12:12）。',
  RULES_DESC_10: 'ご質問がある場合や、カスタマーサービスに連絡したい場合は、「ラウンドID」番号を参照番号として使用してください（または、ラウンド番号のスクリーンショットを撮ってください）。',
  CASHING_OUT: 'キャッシュアウトする',
  RULES_DESC_11: 'ベットが承認されると、現在のゲームラウンドに参加できます。キャッシュアウトするには、「キャッシュアウト」ボタンをクリックまたはタップします。',
  RULES_DESC_12: 'Hubert Hitsはリアルタイムゲームであるため、お客様のインターネット接続状況によっては「キャッシュアウト」処理の完了にしばらく時間がかかることがあります。',
  RULES_DESC_13: '「キャッシュアウト」をクリックまたはタップすると、ペイアウトリクエストが開始されます。ペイアウトリクエストはその後、クラッシュが起きていなければ、ゲームサーバーによって処理された時点でのマルチプライヤー値で確定します。',
  RULES_DESC_14: '「キャッシュアウト」を選択すると、ゲーム内でアクティブなすべてのベットからの利益が引き出されます。マルチプライヤー値が上昇するにつれ、賞金額が表示され、現在の値がボタン上に表示されます。',
  RULES_DESC_15: 'クラッシュの前にこのボタンをクリックまたはタップすると、ゲームサーバーで確認処理がトリガーされ、最終的な賞金額はリクエストが承認された時点のマルチプライヤー値に従って確定します。',
  AUTO_CASHOUT: '自動キャッシュアウト',
  RULES_DESC_16: 'ベッティング期間中に画面上のパネルにあるトグルスイッチを使って「自動キャッシュアウト」を有効にします。',
  RULES_DESC_18: '注意：選択したマルチプライヤー値がクラッシュマルチプライヤー値以下である場合、自動キャッシュアウトを有効にすると、選択したマルチプライヤー値で支払われます。ゲームラウンドが開始されてからこれらの設定を変更することはできませんが、「キャッシュアウト」ボタンを使うことにより、それよりも低い値で手動キャッシュアウトをすることはできます。',
  RULES_DESC_19: '既定の数のゲームラウンドでの自動プレイでは、ご自身で設定したベットを繰り返す自動プレイ機能を設定できます。',
  RULES_DESC_20: 'ベットを実施して、自動プレイ値を設定し、「自動プレイ」ボタンをクリックまたはタップすることにより、自動プレイ機能を有効化します。',
  RULES_DESC_21: '自動プレイウィンドウが表示されると、あとは賭けを繰り返したいゲームラウンド数を選択するだけです。お客様のカジノの管轄区域によっては、その他の追加設定にアクセスできることもあります。',
  RULES_DESC_22: '自動プレイは「開始」ボタンをタップまたはクリックした後に有効化されます。',
  RULES_DESC_23: '自動プレイが実行されている間は、お客様のベットは各ゲームラウンドごとに自動的に確定されます。「自動キャッシュアウト」設定またはベット額を変更するには、ベットをキャンセルする必要があります。',
  RULES_DESC_24: '自動プレイ機能を停止するには、自動プレイウィンドウを開き、「停止」ボタンをクリックまたはタップします。',
  RULES_DESC_25: '次の状況では、自動プレイ機能は自動的に無効となります：',
  RULES_DESC_26: '選択した自動プレイラウンド数がゼロに近づいているという警告メッセージを画面上に受信した場合。',
  RULES_DESC_27: '残高が不足しているため、自動プレイが継続できない場合。',
  RULES_DESC_28: '残高が低下、上昇した場合、または1回分の賞金が設定で決めた値を上回り、「自動プレイ停止」が複数回発動された場合。',
  RETURN_PLAYER: 'リターン・トゥ・プレイヤー（RTP）',
  RULES_DESC_29: 'Hubert Hitsゲームでの最適な理論上の「リターン・トゥ・プレイヤー (RTP)」は99%です。',
  LAST_RESULT: '前回の結果',
  RULES_DESC_30: '直近の複数ラウンドのクラッシュ値は「ベット」タブ （モバイルの場合）に表示されるか、ゲームプレイ中に見ることができます。横線3本のメニューアイコンからリーダーボードを見ることができます。',
  NAVIGATION_CONTROL: 'ナビゲーションコントロール',
  RULES_DESC_34: '「音量コントロール」ボタンをクリックまたはタップしてサウンドをミュートできます。「音量コントロール」アイコンをもう一度クリックまたはタップするとミュートを解除できます。',
  RULES_DESC_35: '「マイベット履歴」を確認するには、メニューアイコンをクリックまたはタップして、ゲーミングアクティビティを表示します。デフォルトで、当日のセッションが最初に表示されます。特定のラウンドの詳細を表示するには、リストから選択します。エントリーごとに日付、ベット、マルチプレイヤー、キャッシュアウト額が表示されます。',
  RULES_DESC_36: '「全画面」ボタンをクリックまたはタップすると、全画面モードを開始できます。このモードを終了するには、全画面ボタンをもう一度長押しするか、キーボードの「Esc」キーを押します。',
  GAME_CONVENIENCES: 'ゲームでの障害',
  RULES_DESC_38: '技術的な不具合があった場合は、ゲームは停止されます。有効なキャッシュアウト額は変わらず、キャッシュアウトされなかった金額はすべて返金されます。システムやソフトウェアの不具合によりキャンセルされたラウンドで賭けられた金額はすべて返金されます。',
  RULES_DESC_39: '残高や賭け金に関して問題が発生した場合または質問がおありの場合は、カスタマーサポートまでご連絡ください。',
  PINGOO_TITLE: 'Pingoo Splash',
  PINGOO_GAME_INFO: 'Pingoo Splashは、楽しく遊べる「クラッシュ」系のマルチプレイヤーゲームです。このゲームに含まれるマルチプライヤーは1.00倍からで、クラッシュが起こるまで、事前にランダムに決定された値まで上昇します。このゲームの目的は、クラッシュが起こる前にキャッシュアウトし、マルチプライヤーで倍増した賭け金を確保することです。怖いもの知らずで冒険好きのPingooが、高く飛ぼうともくろむ、腹を空かせたシャチを避けながら進んで行く危険なフライトに加わりましょう。',
  PINGOO_RULE_NAME_2: 'ベット期間終了後にゲームに参加した場合や、現在のラウンドに実施したベットがない場合、「次回ラウンドまで待機中」というメッセージが表示されます。観戦者として、現在のラウンドを見守りながら、次のラウンドのベットを実施することができます。',
  PINGOO_RULE_NAME_3: 'ベットが承認されると、現在のゲームラウンドに参加できます。キャッシュアウトするには、「キャッシュアウト」ボタンをクリックまたはタップします。',
  PINGOO_RULE_NAME_4: '{{gameName}}はリアルタイムゲームであるため、お客様のインターネット接続状況によっては「キャッシュアウト」処理の完了にしばらく時間がかかることがあります。',
  PINGOO_RULE_NAME_5: '自動プレイが実行されている間は、お客様のベットは各ゲームラウンドごとに自動的に確定されます。「自動キャッシュアウト」設定またはベット額を変更するには、ベットをキャンセルする必要があります。',
  PINGOO_RULE_NAME_6: '{{gameName}}ゲームでの最適な理論上の「リターン・トゥ・プレイヤー（RTP）」は99%です。',
  NETWORK_ERROR: '現在オフラインです。インターネット接続をご確認ください。',
  PLAY: '遊ぶ',
  START: '始める',
  AUTO: 'オート',
  GEMX_TITLE: 'Gem X',
  GEMX_GAME_INFO: 'Gem Xは「クラッシュ」ジャンルの爽快なオンラインマルチプレイヤーゲームです。ゲームが始まると、1.00倍からスタートするマルチプライヤーが、あらかじめランダムに設定された限界値でクラッシュするまで上昇し続けます。プレイヤーはクラッシュが起きる前にキャッシュアウトし、現在の倍率に応じた配当を獲得する必要があります。Gem Xでは、上がり続ける倍率をどこまで追いかけるか、プレイヤーの運とタイミングが試されます。長く勝負するほどリスクは高まりますが、その分より大きなリターンを狙えます。',
  BET_CLOSED: 'ベット受付終了',
  ACCEPT_BETS: 'ベット受付中',
  WIRE_GAME_INFO: 'タイムリミットが迫り、世界が固唾を呑んで見守っています。このスリル満点なカジノミニゲームでは、プレイヤーは巨額の配当と大爆発かの運命を握るスペシャリストとなります。配線を切るたびに配当が倍増し、先へ進むほどリスクが高まります。もし起爆ワイヤーを切ってしまっても焦る必要はありません。クールな男は爆発など振り返りません。ただ埃を払い、リロードし、再び挑むのです。',
  WIRE_GAME_INFO_1: '4つの難易度で自分の度胸を試しましょう。慎重派向けのイージー（配線12本）、素早い倍率アップを狙うプレイヤー向けのノーマル（6本）やハード（4本）、そして究極の勝率50%に挑むハードコア（2本）があります。配線が少ないほど、得られるリターンが大きくなります。クールに決めるか、すべてを賭けるか。あなたの次の一手がすべてを変えるかもしれません。',
  WIRE_HOW_TO_PLAY_DESC_1: 'リスクの選択：4つの難易度から選択します。イージー（配線12本）、ノーマル（6本）、ハード（4本）、または勝率50%のハードコア（2本）。',
  WIRE_HOW_TO_PLAY_DESC_2: 'ベット額の設定：ベット額を選択します。ベット額が高いほど、切断成功時の獲得可能額も大きくなります。',
  WIRE_HOW_TO_PLAY_DESC_3: 'ベット額の設定：ベット額を入力します。ベット額が高いほど、切断成功時の獲得可能額も大きくなります。',
  WIRE_HOW_TO_PLAY_DESC_4: '配線の切断：配線を手動でクリックして解除するか、「ランダム切断」ボタンを使ってシステムに自動で選ばせます。',
  WIRE_HOW_TO_PLAY_DESC_5: 'オールイン：「すべて解除」ボタンを使えば、1本を残してすべての配線をランダムに切断し、一気に最高倍率を狙うことができます。',
  WIRE_HOW_TO_PLAY_DESC_6: 'キャッシュアウトまたは続行：いつでも勝利金を確定することができます。または、究極のジャックポットを目指して配線を切り続けることも可能です。',
  WIRE_HOW_TO_PLAY_DESC_7: '起爆ワイヤーに注意：「起爆ワイヤー」を切るとラウンド終了です。それでも気にせずリロードして、次のラウンドに挑みましょう。',
  WIRE_RULES_1: '安全な配線を切るたびにマルチプライヤーが上昇します。爆弾を完全に解除すると、次の爆弾へ進み、さらにマルチプライヤーを上げることも可能です。現在のマルチプライヤーの値は爆弾の中央とマルチプライヤーバーに表示され、現在の配当額と、次の予想配当額の両方を確認できます。',
  WIRE_RULES_2: '-/+ボタンを使用するか、あらかじめ設定された金額を選択、または任意の金額を手動入力してベット額を調整します。ベット額を設定したら「ベット」ボタンを押し、配線を切ってマルチプライヤーを上げていきましょう。',
  BALANCE_INDICATOR: '残高インジケーター',
  WIRE_RULES_3: '利用可能な資金と通貨は「残高インジケーター」に表示されます。ゲームを開始する前に、賭け金をカバーするのに十分な残高があることを確認しましょう。ベット、勝ち、負けの直後に残高が即座に反映されない場合は、お手数ですがゲームをリスタートしてください。',
  CASHING_OUT: 'キャッシュアウトする',
  WIRE_RULES_4: '爆弾が完全に解除される前に勝利金を確定するには、「キャッシュアウト」ボタンをクリックまたはタップしてください。The Wireはリアルタイムゲームのため、インターネット接続の状況によってはキャッシュアウトの動作にわずかな遅延が生じる場合があります。',
  AUTO_PLAY_RANDOM: '自動プレイ：ランダム機能',
  WIRE_RULES_5: 'ベットが完了すると、解除ペースを速めるための特殊機能を使用できます：',
  CUT_RANDOM_1: 'ランダムに1本切断：',
  CUT_RANDOM_2: '1本残してすべて切断：',
  WIRE_RULES_6: 'この機能は配線をランダムに1本選んで切断します。爆弾が解除されるか、起爆ワイヤーを切ってしまうまで何度でも使用できます。',
  WIRE_RULES_7: 'このハイリスクな機能を使用する際は、確認のポップアップウィンドウが表示されます。同じセッション中の以降のラウンドでは、この警告を非表示にすることもできます。',
  WIRE_INFORMATION_AND_RESULTS: 'ゲーム情報と結果',
  WIRE_INFO_HEAD_1: '還元率（RTP）：',
  WIRE_INFO_HEAD_2: '前回の結果：',
  WIRE_INFO_HEAD_3: 'ナビゲーション：',
  WIRE_INFO_DESC_1: ' The Wireの最適な理論上の還元率（RTP）はXX%です。',
  WIRE_INFO_DESC_2: '最近のラウンドで獲得したマルチプライヤーは「ラウンド履歴」タブに表示されます。',
  WIRE_INFO_DESC_3: '音量アイコンで音声のオンオフ、メニュー（ハンバーガー）アイコンでベット履歴の確認、フルスクリーンボタンで全画面表示の切り替えができます。',
  TECHNICAL_ISSUES: '技術的な問題',
  WIRE_RULES_8: '技術的な不具合が発生した場合、ゲームは中断されます。有効なキャッシュアウトはそのまま維持され、キャンセルされたラウンドのキャッシュアウト分および未キャッシュアウト分およびベット額は返金されます。残高やベットに関する問題が発生した場合は、カスタマーサポートまでお問い合わせください。',
  CASHOUT: 'キャッシュアウト',
  WIRE_NAME: 'The Wire：ハイステークス・ディフューザル',
  WINNING_AMOUNT: '獲得金額',
  DIFFICULTY: '難易度',
  YOU_CASH_OUT: 'キャッシュアウトしました！',
  CASH_WIN: '勝ち',
  WIRE_SKIP: 'クリックしてスキップ',
  WIRE_BET_WARNING: '先にベ\n\n\nットして\n\n\nください',
  WIRE_LEVEL_1: 'イージー',
  WIRE_LEVEL_2: 'ノーマル',
  WIRE_LEVEL_3: 'ハード',
  WIRE_LEVEL_4: 'ハードコア',
  WIRE_LEVEL_OK: 'OK',
  WIRE_LEVEL_DES1: '安全な配線だけを切断して爆弾を解除してください\n切断に成功するたびにマルチプライヤーが上昇します\n起爆ワイヤーに触れる\nと即座に爆発します。\n\n',
  WIRE_LEVEL_DES2: '\n\n大金を手にするか、爆発で吹き飛ぶか\nその運命は1本のワイヤーにかかっています。\n小切手を手にする勝者になりましょう。',
  WIRE_LEVEL_EASY: 'アマチュアレベルの配線：配線は全\n12本、起爆ワイヤーは1本。',
  WIRE_LEVEL_MEDIUM: '標準的な点火回路：安全な配線が5本、\n起爆ワイヤーは1本。',
  WIRE_LEVEL_HARD: '危険な密度：安全な配線が3本、\n起爆ワイヤーは1本。',
  WIRE_LEVEL_HARDCORE: '二者択一のデッドマンスイッチ。\n50%の確率で爆発。',
  WIRE_LOOSE_LEVEL: 'レベル',
  WIRE_TRY_AGAIN: 'リトライ',
  WIRE_CONTINUE: '続ける',
  WIRE_CASHOUT: 'キャッシュアウト',
  WIRE_WIN_DES1: '勝ち',
  WIRE_WIN_DES2: '次の勝利',
  WIRE_CUT_ALL: 'はい（すべて切断）',
  WIRE_CUT_ALL_DES: 'すべての配線を切断しますか？この操作は取り消せません。',
  WIRE_SHOW_AGAIN: '今後表示しない',
  WIRE_CANCEL: 'キャンセル',
  WIRE_WARNING: '警告！',
  WIRE_NETWORK_ERROR: 'ネットワークエラー',
  WIRE_NETWORK_ERROR_DES: 'インターネット接続を確認し、\nもう一度お試しください。',
  WIRE_LOST: '負け',
  WIRE_BOMB_DEFUSE: '爆弾解除',
  WIRE_DEFUSE: '解除成功',
  WIRE_WELL_DONE: 'お見事！',
  WIRE_SOUND: '爆発音',
  MODE: 'モード',
  CHANGE_MODE: 'モード変更',
  WIRE_MAX_MULTIPLIER: '最大倍率 {{ multiplier }}x に到達しました。賞金は自動的にキャッシュアウトされました！',
  INTERNAL_ERROR: '内部サーバーエラー',
  SESSION_EXPIRED: 'セッションの有効期限が切れました。ベットを続けるには更新してください',
  INSUFFICIENT_FUNDS: '残高不足'
}

export default {
  ...translationKeys
}
